// Parses a recording: one "ms<TAB>base64" line per frame, ms counted from connecting.
export interface RecordedLine { ms: number; b64: string }

export function parseTsv(text: string): RecordedLine[] {
  const out: RecordedLine[] = [];
  for (const raw of text.split(/\r?\n/)) {
    const line = raw.trim();
    if (!line || line.startsWith('#')) continue;
    const tab = line.indexOf('\t');
    if (tab < 0) continue;
    const ms = Number(line.slice(0, tab));
    const b64 = line.slice(tab + 1).split('\t')[0]!.trim();
    if (Number.isFinite(ms) && b64) out.push({ ms, b64 });
  }
  out.sort((a, b) => a.ms - b.ms);
  return out;
}
